var map = {
	"./en.json": [
		1752,
		9
	],
	"./en_CA.json": [
		1753,
		10
	],
	"./en_GB.json": [
		1754,
		11
	],
	"./en_US.json": [
		1755,
		12
	],
	"./fr_CA.json": [
		1756,
		13
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1663;
module.exports = webpackAsyncContext;